import type {ReactAction} from '@netx/core/bootstrap';
import {appRouter} from '@netx/core-next/instance/router';
import {faUserViewfinder} from '@netx/core-icons';
import {canManageSystemPeople} from '../enablers/canManageSystemPeople';
import {SystemPeopleLabel} from '../locales';
import {SystemPeopleRouteUtil, SYSTEM_PEOPLE_ROUTE_REGEX} from '../routes';

export const systemPeopleActionRouteIcon = faUserViewfinder;

/**
 * Route to system People
 * @param params
 * @returns Action
 */
export const systemPeopleActionRoute = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'system-people-route',
	cb: async () => appRouter.navigate(SystemPeopleRouteUtil.BASE(), true),
	enableTest: () => canManageSystemPeople(),
	icon: systemPeopleActionRouteIcon,
	get label() {
		return SystemPeopleLabel.PEOPLE;
	},
	routeMatch: SYSTEM_PEOPLE_ROUTE_REGEX.BASE,
	...params,
});
